import * as React from 'react';

export function renderProgressBar(width: number, percent: number, height?: number, optionalText?: string) {
    return (
        <div
            style={{
                height: (height ? height : 20) + 'px', width: width + 'px',
                border: '1px solid #AAA', alignContent: 'left', backgroundColor: '#FFF'
            }}>
            <div
                style={{
                    height: (height ? height : 20) + 'px', width: percent + '%', backgroundColor: '#1a8cff',
                    textAlign: 'right', color: '#ccc', fontWeight: 'bold', padding: '1px', boxSizing: 'border-box'
                }}
            >
                {percent + '%'}
                {optionalText && '/' + optionalText}
                <div className='value_sort' style={{ display: 'none' }}>{percent}</div>
                <div className='value_export' style={{ display: 'none' }}>{percent + '%'}</div>
            </div>
        </div>
    );

}
